import { useContext, useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"
import { MyContext } from "../../Components/Context"
import api from "../../api/api"
import Pagination from "../../Components/Pagination"

const ProprietairesPremium = () =>{

    const navigate = useNavigate()
    const [owner, setOwner] = useState([])
    const [page, setPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalROws, setTotalRows] = useState(0)
    const {setActifItem} = useContext(MyContext)
    const [actif, setActif] = useState([true, false])
    const [isActif, setIsActif] = useState(null)


    useEffect(()=>{

        const getData = async ()=>{

            try {
                
                const data = await api.get('/offres/owners', {
                    params : {
                        page : page
                    }
                });
                
                setOwner(data.data.rows)
                setTotalRows(data.data.count)
                setPage(page + 1)
                
            } catch (error) {
                
                console.error(error)
            }
            
        }

        getData()
        
    }, [currentPage])
    

    
    return (
        <div className="animate-fade">
            <h2 className="mb-4 text-2xl font-bold dark:text-gray-200">Propriétaires Premium</h2>
            <p className="dark:text-gray-200">Liste des propriétaires premium...</p>

            <div className="flex flex-row flex-wrap items-center justify-start gap-3 my-10">
            {
                actif.map((item, idx)=>(
                    <button className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${isActif === item ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                        onClick={()=>{
                            
                            if(isActif === item){
                                setIsActif(null)
                            }else{
                                
                                setIsActif(item)
                            }
                        }}
                    >
                        {item ? 'Actif' : 'Inactif'}
                    </button>
                ))
                }
            </div>
            
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    
                    <thead className="font-medium text-gray-600 border-b bg-gray-50 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600">
                        <tr>
                            <th className="px-6 py-3"></th>
                            <th className="px-6 py-3">Proprietaire</th>
                            <th className="px-6 py-3">Debut subscription</th>
                            <th className="px-6 py-3">Fin subscription</th>
                            <th className="px-6 py-3">Offre</th>
                            <th className="px-6 py-3">Actif</th>
                        </tr>
                    </thead>
                    
                    <tbody className="text-gray-600 divide-y">
                        {
                            owner.map((item, idx) => {
                                
                                if(isActif === item.isValid || isActif == null){
                                    
                                    return (
                                    
                                        <tr key={idx} className="w-full text-left duration-300 rounded cursor-pointer animate-fade hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200 hover:dark:text-gray-700"
                                            onClick={()=>{
                                                navigate(`/proprietaires/details/${item.owner.id}`)
                                                setActifItem('Annonces')
                                            }}
                                        >
                                            
                                                <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                    <img alt="" src={item.owner.client.picture ? `${process.env.REACT_APP_API_PICTURE_URL}${item.owner.client.picture}` : "https://randomuser.me/api/portraits/men/86.jpg"} className="w-10 h-10 rounded-full" />
                                                </td>
                                                <td className={"px-6 py-4 whitespace-nowrap"}>{item.owner.client.firstname} {item.owner.client.lastname}</td>
                                                <td className={"px-6 py-4 whitespace-nowrap"}>{new Date(item.startDate).toLocaleDateString()}</td>
                                                <td className={"px-6 py-4 whitespace-nowrap"}>{new Date(item.endDate).toLocaleDateString()}</td>
                                                <td className={"px-6 py-4 whitespace-nowrap"}>{item.offer.name}</td>
                                                <td className={"px-6 py-4 whitespace-nowrap"}> 
                                                    <span className={`px-2 py-1 rounded-xl ${item.isValid ? 'bg-green-300' : 'bg-red-300'} ${item.isValid ? 'text-green-700' : 'text-red-700'}`}>
                                                        {item.isValid ? 'Oui' : 'Non'}
                                                    </span>
                                                </td>
                                        </tr>
                                    
                                    )
                                }
                            return false
                        })
                        }
                    </tbody>
                </table>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalROws}
                    onPageChange={()=>setCurrentPage(currentPage + 1)}
                />
            </div>
        </div>
      );
} 

export default ProprietairesPremium